// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";
import '../style.css';

function Home() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://culturlingua.com/api.php")
      .then((response) => response.json())
      .then((data) => setData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    emailjs.send('service_9lb5qor', 'template_lbosaog', data, 'E34tJabSp_CQoJAQZ')
      .then(() => alert("Tu formulario ha sido enviado exitosamente."))
      .catch(() => alert("Hubo un error. Intenta nuevamente."));
  };

  return (
    <div className="home-wrapper">
      <Helmet>
        <title>Culturlingua | Inglés en Tlaquepaque y Online — Guadalajara</title>
        <meta name="description" content="Aprende inglés con profesores certificados en Tlaquepaque o 100% online. Más de 20 años formando hablantes reales. Niveles A1 a C1, horarios flexibles." />
        <meta name="keywords" content="clases de inglés Tlaquepaque, inglés online Guadalajara, curso de inglés, escuela de idiomas Jalisco, inglés certificación" />
        <meta property="og:title" content="Culturlingua | Inglés en Tlaquepaque y Online" />
        <meta property="og:description" content="Más de 20 años formando hablantes reales. Clases presenciales en Tlaquepaque y online desde cualquier lugar." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://culturlingua.com/" />
        <link rel="canonical" href="https://culturlingua.com/" />
      </Helmet>

      {/* ── HERO ── */}
      <section className="hero-modern">
        <div className="hero-bg"></div>
        <div className="hero-inner">

          {/* Left: copy */}
          <div className="hero-left">
            <div className="hero-eyebrow">Tlaquepaque · Guadalajara · Online</div>
            <h1 className="hero-title">
              El inglés que<br />
              <em>transforma</em><br />
              tu futuro.
            </h1>
            <p className="hero-sub">
              Más de 20 años formando hablantes reales. Clases presenciales en Tlaquepaque
              y online desde cualquier lugar — con profesores de verdad.
            </p>
            <div className="hero-buttons">
              <Link to="/ingles-online" className="btn-glow">💻 Ver Clases Online</Link>
              <Link to="/Cursos" className="btn-outline">🏫 Cursos Presenciales</Link>
            </div>
            <div className="trust-badges">
              <span>✅ Profesores Certificados</span>
              <span>✅ Horarios Flexibles</span>
              <span>✅ +300 alumnos activos</span>
            </div>
          </div>

          {/* Right: stats cards */}
          <div className="hero-visual">
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Años formando hablantes de inglés en Jalisco</div>
            </div>
            <div className="level-card">
              <div className="level-card-title">Niveles que impartimos</div>
              <div className="level-bars">
                {[['A1','100%'],['B1','100%'],['B2','100%'],['C1','75%']].map(([lvl, w]) => (
                  <div className="level-bar" key={lvl}>
                    <span className="level-bar-label">{lvl}</span>
                    <div className="level-bar-track">
                      <div className="level-bar-fill" style={{width: w}}></div>
                    </div>
                    <span className="level-bar-pct">✓</span>
                  </div>
                ))}
              </div>
            </div>
            <Link to="/Examen-de-ubicacion" className="exam-cta-card">
              <div className="exam-icon">📝</div>
              <div className="exam-text">
                <strong>¿No sabes tu nivel?</strong>
                <span>Haz el examen de ubicación gratis →</span>
              </div>
            </Link>
          </div>

        </div>
      </section>

      {/* ── STATS BAND ── */}
      <div className="stats-band">
        <div className="stats-band-inner">
          {[
            ['20+', 'Años de experiencia'],
            ['500+', 'Alumnos activos'],
            ['100%', 'Profesores certificados'],
            ['A1→C1', 'Niveles completos'],
          ].map(([num, label]) => (
            <div className="stat-band-item" key={label}>
              <div className="stat-band-num">{num}</div>
              <div className="stat-band-label">{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── MODALIDADES ── */}
      <section className="modalidades-section">
        <div className="modalidades-header">
          <div className="section-tag">Modalidades</div>
          <h2 className="section-headline">Tu aprendizaje,<br /><em>a tu manera</em></h2>
          <p className="section-sub">Elige la modalidad que mejor se adapte a tu ritmo de vida y metas.</p>
        </div>
        <div className="cards-grid">

          <div className="modal-card">
            <div className="modal-card-accent"></div>
            <div className="modal-card-body">
              <div className="modal-icon">🏫</div>
              <h3>Presencial</h3>
              <p>Inmersión total en nuestras aulas en Tlaquepaque, Jalisco.</p>
              <ul className="modal-features">
                <li>Grupos pequeños y personalizados</li>
                <li>Profesores certificados en aula</li>
                <li>Horarios matutinos y vespertinos</li>
              </ul>
              <Link to="/Cursos" className="modal-link">Ver cursos →</Link>
            </div>
          </div>

          <div className="modal-card">
            <div className="modal-card-accent green"></div>
            <div className="modal-card-body">
              <div className="modal-icon">💻</div>
              <h3>Online</h3>
              <p>Aprende desde cualquier lugar con plataforma digital interactiva.</p>
              <ul className="modal-features">
                <li>Clases en vivo con profesor real</li>
                <li>Plataforma LinguaSkills incluida</li>
                <li>Clubes de conversación internacionales</li>
              </ul>
              <Link to="/ingles-online" className="modal-link">Ver clases online →</Link>
            </div>
          </div>

          <div className="modal-card">
            <div className="modal-card-accent purple"></div>
            <div className="modal-card-body">
              <div className="modal-icon">🏢</div>
              <h3>Empresas</h3>
              <p>Programas corporativos con seguimiento y reportes para RRHH.</p>
              <ul className="modal-features">
                <li>Grupos in-company o remotos</li>
                <li>Reporte de avance por empleado</li>
                <li>Horarios adaptados al equipo</li>
              </ul>
              <Link to="/courses/Empresas" className="modal-link">Ver programas →</Link>
            </div>
          </div>

        </div>
      </section>

      {/* ── GALLERY ── */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="section-title">Momentos Culturlingua</h2>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000 }}
            loop={true}
            spaceBetween={20}
            slidesPerView={1}
            breakpoints={{ 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
            className="modern-swiper"
          >
            {[
              { src: './assets/virtual-class.jpeg', caption: 'Clases en Vivo' },
              { src: './assets/school.avif', caption: 'Comunidad Real' },
              { src: './assets/tlaquepaque.jpg', caption: 'Cultura y Lengua' },
              { src: './assets/number.webp', caption: 'Resultados Medibles' },
            ].map(({ src, caption }) => (
              <SwiperSlide key={caption}>
                <div className="gallery-card">
                  <img src={src} alt={caption} />
                  <div className="caption">{caption}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section className="testimonials-section">
        <div className="testimonials-header">
          <div className="section-tag">Testimonios</div>
          <h2 className="section-headline" style={{color:'white'}}>Lo que dicen nuestros <em style={{color:'var(--gold-light)'}}>alumnos</em></h2>
          <p className="section-sub" style={{color:'rgba(255,255,255,0.5)', margin:'0 auto'}}>Resultados reales de personas reales.</p>
        </div>
        <div className="testimonials-grid">

          <div className="testi-card">
            <div className="testi-stars">★★★★★</div>
            <p className="testi-text">
              Llevaba años sin poder hablar inglés con confianza. En Culturlingua en solo
              6 meses ya tenía conversaciones reales en el trabajo.
            </p>
            <div className="testi-author">
              <div className="testi-avatar">MR</div>
              <div>
                <div className="testi-name">María R.</div>
                <div className="testi-detail">Nivel B2 · Modalidad Online</div>
              </div>
            </div>
          </div>

          <div className="testi-card featured">
            <div className="testi-stars">★★★★★</div>
            <p className="testi-text">
              Los profesores realmente se preocupan por tu progreso. El ambiente presencial
              en Tlaquepaque es increíble, siempre quería ir a clase.
            </p>
            <div className="testi-author">
              <div className="testi-avatar">JL</div>
              <div>
                <div className="testi-name">Jorge L.</div>
                <div className="testi-detail">Nivel C1 · Modalidad Presencial</div>
              </div>
            </div>
          </div>

          <div className="testi-card">
            <div className="testi-stars">★★★★★</div>
            <p className="testi-text">
              La plataforma online es muy completa. Puedo practicar entre clases y
              el seguimiento del maestro hace toda la diferencia.
            </p>
            <div className="testi-author">
              <div className="testi-avatar">AP</div>
              <div>
                <div className="testi-name">Ana P.</div>
                <div className="testi-detail">Nivel B1 · Modalidad Online</div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ── PRÓXIMOS INICIOS ── */}
      <section className="dates-section">
        <div className="dates-inner">

          <div>
            <div className="section-tag">Inscripciones Abiertas</div>
            <h2 className="section-headline">Próximos<br /><em>Inicios</em></h2>
            <p className="section-sub">Reserva tu lugar antes de que se llenen los grupos.</p>
            <div className="proximos-dates">
              {data.length > 0 ? data.map((item, index) => (
                <Link to="/contacto" className={`date-row${index === 0 ? ' next' : ''}`} key={item.id}>
                  <div className={`date-badge${index === 0 ? ' gold-bg' : ''}`}>
                    <span>{index === 0 ? '🚀' : '📅'}</span>
                  </div>
                  <div className="date-info">
                    <div className="date-label">{item.fecha}</div>
                    <div className="date-meta">Presencial y Online · Todos los niveles</div>
                  </div>
                  {index === 0
                    ? <span className="date-next-badge">Próximo</span>
                    : <span className="date-arrow">→</span>
                  }
                </Link>
              )) : (
                <div className="date-row" style={{justifyContent:'center', color:'var(--muted)'}}>
                  Cargando fechas...
                </div>
              )}
            </div>
          </div>

          <div className="exam-big-card">
            <div className="section-tag">Gratis · 10 minutos</div>
            <h3>¿No sabes qué nivel eres?</h3>
            <p>Haz nuestro examen de ubicación y te diremos exactamente en qué nivel empezar.</p>
            <div className="exam-pills">
              <span className="exam-pill">⏱️ 10 min</span>
              <span className="exam-pill">🆓 Gratis</span>
              <span className="exam-pill">📱 Cualquier dispositivo</span>
              <span className="exam-pill">🏆 Resultado inmediato</span>
            </div>
            <Link to="/Examen-de-ubicacion" className="exam-btn">
              Hacer el examen gratis →
            </Link>
            <p className="exam-fine">Sin registro. Sin tarjeta. Sin compromisos.</p>
          </div>

        </div>
      </section>

      {/* ── CONTACT ── */}
      <section className="contact-section">
        <div className="contact-inner">

          <div className="contact-left">
            <div className="section-tag">Contáctanos</div>
            <h2 className="section-headline">Hablemos de<br /><em>tus metas</em></h2>
            <p className="section-sub">¿Dudas entre Online o Presencial? ¿No sabes tu nivel? Te ayudamos sin compromiso.</p>
            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-info-icon">📍</div>
                <div className="contact-info-text">
                  <strong>Dirección</strong>
                  <span>Reforma 31, Tlaquepaque, Jalisco, México</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">📞</div>
                <div className="contact-info-text">
                  <strong>Teléfono</strong>
                  <span>+52 33 3344 9139</span>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">💬</div>
                <div className="contact-info-text">
                  <strong>WhatsApp</strong>
                  <span>Respuesta en menos de 1 hora en horario de oficina</span>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              <div className="form-row" style={{marginBottom:'16px'}}>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">Nombre</label>
                  <input className="form-input" type="text" name="nombre" placeholder="Tu nombre" required />
                </div>
                <div className="form-field" style={{marginBottom:0}}>
                  <label className="form-label">WhatsApp</label>
                  <input className="form-input" type="tel" name="telefono" placeholder="+52 33..." required />
                </div>
              </div>
              <div className="form-field">
                <label className="form-label">Correo electrónico</label>
                <input className="form-input" type="email" name="correo" placeholder="tu@correo.com" required />
              </div>
              <div className="form-field">
                <label className="form-label">¿En qué podemos ayudarte?</label>
                <textarea className="form-input form-textarea" name="pregunta" placeholder="Cuéntanos tu situación..." required></textarea>
              </div>
              <button type="submit" className="form-submit">
                Enviar Mensaje →
              </button>
            </form>
          </div>

        </div>
      </section>

    </div>
  );
}

export default Home;
